'use strict';

const styles = theme => ({
    paperHeader: {
		borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
	},
	detailsTitle: {
		paddingLeft: '15px',
		fontSize: theme.typography.pxToRem(20),
		fontWeight: 'bold'
	},
    contentWrapper: {
		margin: '40px 16px',
	},
    progressbar: {
		width: '100%',
		height: '50%',
		textAlign: 'center'
	},
});

export default styles;